/* src/app/components/ortho/ortho-menu/ortho-menu.component.scss */
.navbar-collapse {
  background: #fff;
  padding: 20px;
}
@media screen and (min-width: 768px) {
  .navbar-collapse {
    background: transparent;
    padding: 0;
  }
}
/*# sourceMappingURL=ortho-menu.component.css.map */
